import React from 'react'
import './Raya.css'

export const Raya = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1 50.8"><defs></defs><g id="Capa_2" data-name="Capa 2"><g id="Capa_1-2" data-name="Capa 1"><rect className="cls-1" width="1" height="50.8"/></g></g></svg>
)